import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { UserInfoService } from 'src/app/shared/services/user-info.service';

/**
 * The credit due-diligence page is visible on the dev environment for everyone;
 * on other environments only admins and members of the ORG_ZRCH group may reach
 * it. Non-permitted users are sent back to the cockpit.
 */
export const dueDiligenceGuard: CanActivateFn = (): boolean | UrlTree => {
  const routing = inject(RoutingService);
  const userInfo = inject(UserInfoService);
  const router = inject(Router);

  if (
    routing.isDev() ||
    userInfo.isAdmin ||
    userInfo.hasRoleOrGroup('ORG_ZRCH')
  ) {
    return true;
  }
  return router.createUrlTree(['/cockpit']);
};
